import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
    selector: 'app-input-color',
    templateUrl: './input-color.component.html',
    styleUrls: ['./input-color.component.sass'],
})
export class InputColorComponent implements OnInit {
    @Input()
    config: IFieldConfig;
    @Input()
    group: FormGroup;
    @Input()
    typeCes?: TypeCesEnum | undefined;
    @Output()
    onSelect: EventEmitter<any> = new EventEmitter();
    @Output()
    onBlur: EventEmitter<any> = new EventEmitter();
    @Output()
    onChange: EventEmitter<any> = new EventEmitter();
    @Output()
    selectionChange: EventEmitter<any> = new EventEmitter();
    @Output()
    onClick: EventEmitter<any> = new EventEmitter();
    @Output()
    onFileClick: EventEmitter<any> = new EventEmitter();
    @Output()
    onFileDelete: EventEmitter<any> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    get typeComponentFieldEnum() {
        return TypeComponentFieldEnum;
    }

    get typeCesEnum() {
        return TypeCesEnum;
    }

    onColorChange(event: any): void {
        const color = event.target.value;
        this.group.get(this.config.name)?.setValue(color);
        this.onChange.emit(color);
    }
} 